// extracted by mini-css-extract-plugin
export default {"Stack":"Stack_Stack__303Fj","Stack--centered":"Stack_Stack--centered__zVhlE"};